import { render, staticRenderFns } from "./ForumFuLiComponent.vue?vue&type=template&id=5f1992ad&scoped=true"
import script from "./ForumFuLiComponent.vue?vue&type=script&lang=js"
export * from "./ForumFuLiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1992ad",
  null
  
)

export default component.exports